import React, { useEffect, useState } from "react";
import Section from "../Section";
import Breadcrumb from "../Breadcrumb";
import SectionHeading from "../SectionHeading";
import { pageTitle } from "../../helpers/PageTitle";
import { Helmet } from "react-helmet";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { FaPlay } from "react-icons/fa";

const api = "AIzaSyBiNSppdp9mrw_NCMLr2aG2M-k0a5hmE_o";
const channelId = "UCzjtEsnXEIY0XTH_krchs0A";
const fetchUrl = `https://www.googleapis.com/youtube/v3/search?key=${api}&channelId=${channelId}&part=snippet,id&order=date&maxResults=20`;

const fallbackVideoData = [
  {
    videoId: "eQ3VBrAd4hI",
    title: "Understanding Male Infertility | male infertility causes | testosterone | Dr. Archana Shrivastava",
    publishedAt: "2025-05-09T00:00:00Z",
  },
  {
    videoId: "UFRmMDniLbk",
    title: "Primary factor of infertility | Male | Female | Dr. Archana Shrivastava | Pluro Jabalpur Fertility Centre",
    publishedAt: "2025-05-08T00:00:00Z",
  },
  {
    videoId: "GKc1PJA04yw",
    title: "Infertile couple | Causes of infertility | Fertility solutions | OPD | Dr. Archana Shrivastava",
    publishedAt: "2025-05-07T00:00:00Z",
  },
  {
    videoId: "yazy36SHbVE",
    title: "Patient Story | IVF Story | Gynaecologist | IVF Specialist | Dr. Archana Shrivastava | Awareness",
    publishedAt: "2025-04-23T00:00:00Z",
  },
  {
    videoId: "46nyueKjX1M",
    title: "7 साल का इंतज़ार हुआ खत्म | माता-पिता बनने का सुख | डॉ. अर्चना श्रीवास्तव | जबलपुर फर्टिलिटी सेंटर",
    publishedAt: "2025-04-08T00:00:00Z",
  },
  {
    videoId: "hlRdznUBXq4",
    title: "9 साल का इंतज़ार, खुशियों की सौगात | डॉ. अर्चना श्रीवास्तव | जबलपुर फर्टिलिटी सेंटर | जबलपुर",
    publishedAt: "2025-04-05T00:00:00Z",
  },
  {
    videoId: "5vqtECIz6T4",
    title: "24 साल की उम्मीद, एक खूबसूरत चमत्कार! ✨👶",
    publishedAt: "2025-04-04T00:00:00Z",
  },
  {
    videoId: "SStIVA44KHM",
    title: "She never expected her journey to lead to IVF | Dr. Archana Shrivastava | Pluro Jabalpur Fertility Centre",
    publishedAt: "2025-03-18T00:00:00Z",
  },
  {
    videoId: "LbMWZLYg32w",
    title: "Parenthood Should Be a Choice, Not a Chance | Dr. Archana Shrivastava | Pluro Jabalpur Fertility Centre",
    publishedAt: "2025-03-11T00:00:00Z",
  }
];

export default function Blog() {
  pageTitle("Video Blogs");
  
  const [isOpen, setOpen] = useState(false);
  const [currentVideoId, setCurrentVideoId] = useState("");
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const resJson = await response.json();
        const result = resJson.items
          .filter((doc) => doc.id && doc.id.videoId) // ensure it's a video
          .map((doc) => ({
            videoId: doc.id.videoId,
            title: doc.snippet.title,
            publishedAt: doc.snippet.publishedAt,
          }));
        
        // Use API results or fallback if API returns empty
        setVideos(result.length > 0 ? result : fallbackVideoData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setVideos(fallbackVideoData); // Fallback on error
      }
    };

    fetchData();
  }, []);

  const openVideo = (videoId) => {
    setCurrentVideoId(videoId);
    setOpen(true);
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const truncateTitle = (title, maxLength) => {
    if (title.length <= maxLength) {
      return title;
    }
    return title.substring(0, maxLength) + "...";
  };

  return (
    <>
      <Helmet>
        <title>Video Blogs – Expert IVF Guidance | Pluro Jabalpur Fertility Centre</title>
        <meta name="description" content="Watch IVF video blogs by Pluro Jabalpur Fertility Centre’s experts. Learn about fertility treatments, pregnancy care, and success stories." />
        <meta name="Keywords" content="IVF video blogs, fertility clinic Jabalpur, IVF tips, pregnancy advice, fertility treatment videos, Pluro Jabalpur IVF Centre" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Pluro Jabalpur Fertility Centre" />
        <meta name="publisher" content="Pluro Jabalpur Fertility Centre" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/video-blogs" />
      </Helmet>

      {/* Video Modal using react-modal-video */}
      <ModalVideo 
        channel="youtube" 
        youtube={{ autoplay: 1, mute: 1 }} 
        isOpen={isOpen} 
        videoId={currentVideoId} 
        onClose={() => setOpen(false)} 
      />

      <Section topMd={170} bottomMd={96} bottomLg={70}>
        <Breadcrumb title="Understanding the Psychological and Lifestyle Aspects" />
      </Section>

      <div className="cs_mcp_video_blogs_wrap" style={{ paddingTop: '0' }}>
        <div className="container">
          <div className="row cs_mcp_video_grid">
            {videos.slice(0, 12).map((video, index) => {
              // Generate high quality thumbnail directly from YouTube
              const thumbUrl = `https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`;
              
              return (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index}>
                  <div 
                    className="cs_mcp_video_card h-100 d-flex flex-column"
                    onClick={() => openVideo(video.videoId)}
                  >
                    <div className="cs_mcp_video_thumbnail_wrap">
                      <img 
                        src={thumbUrl} 
                        alt={video.title} 
                        className="cs_mcp_video_thumbnail" 
                      />
                      <div className="cs_mcp_video_overlay"></div>
                      
                      {/* Glassmorphic Play Button */}
                      <div className="cs_mcp_glass_play_btn">
                        <FaPlay style={{ color: '#ffffff', fontSize: '24px', marginLeft: '4px' }} />
                      </div>
                    </div>
                    
                    <div className="cs_mcp_video_content flex-grow-1">
                      <span className="cs_mcp_video_category">{formatDate(video.publishedAt)}</span>
                      <h3 className="cs_mcp_video_title" style={{ fontSize: '18px' }}>
                        {video.title}
                      </h3>
                      <p className="cs_mcp_video_desc mt-2" style={{ fontSize: '14px' }}>
                        Posted by: Dr. Archana Shrivastava
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
